<template>
  <v-card class="mx-auto pa-5">
    <v-card-title class="mx-0 px-0">Create New Shipping Price</v-card-title>
    <v-row>
      <v-col cols="6">
        <v-select v-model="item.customer_rank_id" :items="customerRanks" item-text="name" item-value="id" label="Customer Rank" outlined dense></v-select>
      </v-col>
      <v-col cols="6">
        <v-select v-model="item.service_id" :items="services" item-text="name" item-value="id" label="Service" outlined dense></v-select>
      </v-col>
      <v-col cols="6"><v-text-field dense outlined label="MinWeight" v-model="item.min_weight"/></v-col>
      <v-col cols="6"><v-text-field dense outlined label="Price" v-model="item.price"/></v-col>
      <v-col cols="6"><v-text-field dense outlined label="Currency" v-model="item.currency"/></v-col>
      <v-col cols="6"><v-text-field dense outlined label="Zone" v-model="item.zone"/></v-col>
</v-row>
    <v-card-actions class="mx-0 pa-0">
      <v-spacer></v-spacer>
      <v-btn color="secondary" text @click="onCancel">Cancel</v-btn>
      <v-btn color="primary" text @click="processAdd">Create</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'CreateShippingPrice',
  props: ['onCreated', 'onCancel'],
  data: () => ({
    item: {}
  }),
  computed: {
    ...mapGetters({
      customerRanks: 'customer_rank/all',
      services: 'service/all',
    }),
  },
  methods: {
    ...mapActions({
      createItem: 'shipping_price/create'
    }),
    processAdd() {
      this.createItem(this.item).then(() => {
        this.onCreated();
      });
    }
  }
}
</script>
